import { useState, createContext } from 'react';
import { IntlProvider } from 'react-intl';
import { contentLib } from '../contentLib';
import { Locale, ILocalizationContext } from './types';

export const LocaleContext = createContext<Record<string, unknown>>({});

export const LocalizationContext: React.FC<ILocalizationContext> = ({ children }) => {
  const [locale, setLocale] = useState(Locale.EN);

  const changeLocaleHandler = (language: Locale) => setLocale(language);

  return (
    <LocaleContext.Provider
      value={{
        changeLocale: changeLocaleHandler,
      }}
    >
      <IntlProvider locale={locale} messages={contentLib[locale]}>
        {contentLib[locale] ? children : null}
      </IntlProvider>
    </LocaleContext.Provider>
  );
};
